import gql from "graphql-tag";

//GetPermitChildCountByStatus
export const GET_DASHBOARD_1_PERMIT_CHILD_COUNT_BY_STATUS = gql`
  query ($startDate: String!, $endDate: String!, $sites: [String!]!) {
    GetPermitChildCountByStatus(startDate: $startDate, endDate: $endDate, sites: $sites) {
      code
      success
      message
      results {
        tableData {
          permitStatus
          parentGeneral
          parentToolInstall
          childPermit
        }
        pieChartData {
          permitStatus
          count
        }
      }
    }
  }
`;
